import { render, staticRenderFns } from "./IncidentWorkflow.vue?vue&type=template&id=53c10fde&"
import script from "./IncidentWorkflow.vue?vue&type=script&lang=js&"
export * from "./IncidentWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./IncidentWorkflow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports